import { Component, OnInit, OnDestroy } from '@angular/core';
import { Parameter } from '../models/parameter';
import { ParameterService } from '../services/parameter.service';
import { Alert, AlertType } from '../../shared/alert.model';
import { MessageService } from '../../shared/message.service';
import { Subscription } from 'rxjs';
import { MessageType } from '../../shared/messageType';
import { getAlertMessage } from '../../shared/api-loaders';
import {SecurityService} from '../../shared/security.service';

@Component({
    selector: 're-parameter-list',
    templateUrl: './parameter-list.component.html',
    styleUrls: ['./parameter-list.component.scss'],
    standalone: false
})
export class ParameterListComponent implements OnInit, OnDestroy {

  parameters: Parameter[];
  loading: boolean;
  alert: Alert;
  messageSubscription: Subscription;
  isReadOnlyUser: boolean;

  constructor(private parameterService: ParameterService, private messageService: MessageService,
              private securityService: SecurityService) {
    this.messageSubscription = this.messageService.get().subscribe(message => {
      if (message.type == MessageType.ParameterCreated) {
        this.alert = { type: AlertType.SUCCESS, message: `Parameter ${message.data} has been created successfully` };
        this.clearAlerts();
      }
    })}
  clearAlerts() {
    setTimeout(() => this.alert = null, 5000);
  }
  ngOnDestroy(): void {
    this.messageSubscription.unsubscribe();
  }

  async ngOnInit() {
    this.isReadOnlyUser = await this.securityService.isThisReadOnlyUser();
    this.getParameters();
  }

  getParameters(): void {
    this.loading = true;
    this.parameterService.getParametersByStack().subscribe(parameters => { this.parameters = parameters; this.loading = false; },
      error => {
        this.alert = getAlertMessage(error);
        this.loading = false;
      });
  }

}
